import { createReducer } from '@reduxjs/toolkit'
import { SET_CLAIMS } from './actions'
import { SUCCESS, REQUEST, FAILURE } from '../../constants/statuses'

const initialState = {
  claims: [],
  pagination: {
    page: 1,
    perPage: 10,
    amount: 2
  },
  isLoading: false,
  isError: false
}

export const claimsReducer = createReducer(initialState, {
  [SET_CLAIMS[SUCCESS]]: (state, action) => {
    state.claims = action.payload.data.claims
    state.pagination.amount = action.payload.data.amount
    state.pagination.page = action.payload.paging.page
    state.pagination.perPage = action.payload.paging.count
    state.isLoading = false
  },

  [SET_CLAIMS[REQUEST]]: (state, action) => {
    state.isError = false
    state.isLoading = true
  },

  [SET_CLAIMS[FAILURE]]: (state, action) => {
    state.isLoading = false
    state.isError = true
  }
})